import template	from "./dialog-config-qups.html";
import css		from "./dialog-config-qups.css";

import Dialog	from "dialog";


class ConfigQUPSDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-qups", ConfigQUPSDialog);
  }
  constructor(...args) {
    super(...args);
    
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler.bind(this));

    this.onupdatedevices_handler({detail: application.devices});    

    this.show(...args);
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices.qups.id;
    this.textboxDeviceStatus.value = devices.qups.status;
    this.textboxExternalPower.value = devices.qups.external_power;
    this.textboxCapacitorCharged.value = devices.qups.capacitor_low;    
  }  
  buttonClose_click() {
    this.close();
  }
}

ConfigQUPSDialog.constructor();

export default ConfigQUPSDialog;